export const dateFormater = (locale, dateFormatOptions) => {
  return new Intl.DateTimeFormat(locale, dateFormatOptions);
};
